import Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import ServiceReservation from '../../schema/ServiceReservation';
import setReservationEntityData from './setReservationEntityData';
import assignPerson from './assignPerson';
import assignPlace from './assignPlace';
import tryCreateTxpOwaDate from './tryCreateTxpOwaDate';

export default function setServiceReservationEntityData(
    entity: Entity,
    serviceReservationEntity: any
): ServiceReservation {
    if (entity && serviceReservationEntity) {
        if (isServiceReservationValid(serviceReservationEntity, entity)) {
            let newServiceEntity: ServiceReservation = setReservationEntityData(
                entity,
                serviceReservationEntity,
                true /* isReservationIdRequired */
            );

            let reservationFor = serviceReservationEntity.reservationFor;

            newServiceEntity = {
                ...newServiceEntity,
                ...{
                    entityName: EntityTypeNames.ServiceReservation,
                    entityType: EntityType.ServiceReservation,
                    startTimeFrom: reservationFor.startTimeFrom,
                    startTimeFromUtc: serviceReservationEntity.reservationFor['startTimeFrom/utc'],
                    endTimeFrom: reservationFor.endTimeFrom,
                    endTimeFromUtc: serviceReservationEntity.reservationFor['endTimeFrom/utc'],
                    name: reservationFor.name,
                    underName: assignPerson(newServiceEntity, serviceReservationEntity.underName),
                    provider: assignPerson(newServiceEntity, reservationFor.provider),
                    location: assignPlace({}, reservationFor.location),
                    confirmReservationUrl: serviceReservationEntity.confirmReservationUrl,
                    modifyReservationUrl: serviceReservationEntity.modifyReservationUrl,
                },
            };

            return newServiceEntity;
        }
    }

    return null;
}

/*
 * Check if all required fields are presented for Service Reservation Entity
 */
export function isServiceReservationValid(serviceReservationEntity: any, entity: Entity): boolean {
    if (serviceReservationEntity) {
        let reservationFor = serviceReservationEntity.reservationFor;

        if (
            reservationFor &&
            reservationFor.name &&
            reservationFor.startTimeFrom &&
            tryCreateTxpOwaDate(reservationFor.startTimeFrom, entity) &&
            reservationFor.provider &&
            reservationFor.provider.name
        ) {
            return true;
        }
    }
    return false;
}
